// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b774abd5","453":"f0f669f3","455":"6c40feab","977":"c5272e5c"}[chunkId] + ".chunk.js";
};